import carrierApi from "@/api/carrierApi";

const carrierStore = {
  namespaced: true,
  state: {
    carrierAllList: [],
  },
  mutations: {
    getCarrierAllListByCache(state, data) {
      state.carrierAllList = (data && data.items) || [];
    },
  },
  actions: {
    carrierList({ commit }, data) {
      return carrierApi.carrierList(data);
    },
    addOrModifyCarrier({ commit }, data) {
      return carrierApi.addOrModifyCarrier(data);
    },
    carrierAllList({ commit }, data) {
      if (this.state.carrierAllList != null) {
        return Promise.resolve(this.state.carrierAllList);
      }
      return carrierApi.carrierAllList(data).then((res) => {
        commit("getCarrierAllListByCache", res);
        return res;
      });
    },
  },
};

export default carrierStore;
